import React from 'react';
import { ImgixParams, buildURL } from 'react-imgix';

import { getImgixCropParams } from '$/utils/imgix';
import { MediaRefFragment } from '$/GraphQL/schema/types';
import { isFromDomain } from '$/shared/frontend/utils/string';

export function useImageSrcFromRef(
  ref: MediaRefFragment | null | undefined,
  imgParams: Partial<ImgixParams>
): string | undefined {
  const imgixParams = React.useMemo(() => {
    return getImgixCropParams(ref, imgParams);
  }, [imgParams, ref]);

  if (!ref) return undefined;

  let cleanUrl = ref.imageUrl;
  if (isFromDomain(ref.imageUrl, 'imgix.net')) {
    cleanUrl = ref.imageUrl?.split('?')[0];
  }

  const url = buildURL(cleanUrl, imgixParams);
  return url;
}

export function imageSrcFromRef(
  ref: MediaRefFragment | null | undefined,
  imgParams: Partial<ImgixParams>
): string | undefined {
  const imgixParams = getImgixCropParams(ref, imgParams);

  if (!ref) return undefined;

  let cleanUrl = ref.imageUrl;
  if (isFromDomain(ref.imageUrl, 'imgix.net')) {
    cleanUrl = ref.imageUrl?.split('?')[0];
  }

  const url = buildURL(cleanUrl, imgixParams);
  return url;
}
